// Czy przesyłka ma etykietę do pobrania / wydruku — kafelek w karcie zamówienia, „Drukuj etykiety”
// na liście zamówień i strona przesyłki (23.10.2026: wyniesione z orders/timeline.ts, żeby trzy
// miejsca nie rozjechały się w warunku).
//
// Warunek chroni też przed płatnym zakupem: GET /api/shipments/{id}/label dla przesyłki InPost
// jeszcze niekupionej robi `/buy` (z prawem zapisu zamówień, INT-001) — przycisk druku nie może
// po cichu kupić etykiety.

import type { Shipment } from '../../types/dto.ts';

/** Przesyłka, której etykiety nie da się już drukować (pobranie/podgląd w karcie zostają). */
export function przesylkaNieudana(s: Shipment): boolean {
  return s.status === 'failed' || s.status === 'cancelled' || s.status === 'returned' || s.status === 'error';
}

export function etykietaDostepna(s: Shipment): boolean {
  var dostawca = String(s.provider || '').toLowerCase();
  // WzA ma etykietę OD RAZU po SUCCESS — niezależnie od statusu śledzenia (w SellBase wciąż bywa 'created').
  // Waybill bez wza_shipment_id = nadany poza SellBase (historyczny) — etykiety nie mamy.
  if (dostawca === 'allegro_wza') return !!s.wza_shipment_id;
  // 2026-08-25 (zgłoszenie usera: „przy przesyłkach z Allegro jest opcja drukuj, a tutaj nie ma”):
  // DPD — numer listu i etykieta są dostępne od razu po rejestracji, także w statusie 'created'.
  if (dostawca === 'dpd') return !!s.external_shipment_id;
  // InPost: etykieta powstaje DOPIERO po potwierdzeniu przesyłki. 2026-08-27 (PS 1:105982): 'created'
  // z PRZYDZIELONYM trackingiem ma już etykietę po stronie ShipX (pobranie domyka status na label_generated).
  return !!(s.external_shipment_id || s.shipx_id)
    && ((s.status !== 'created' && s.status !== 'pending' && s.status !== 'draft')
        || !!String(s.tracking_number || '').trim());
}
